import "./PhaseLifecycle.css";

import { CalandarWhiteIcon } from "../../../../assets";
import { OrganisationTypeConstants, UserType } from "../../../../constants";
import { ProjectDates, ProjectPhaseStatus } from "../../../../models";
import { Button } from "../../../forms";
import { PhaseSection } from "./components";

interface PhaseLifecycleProps {
  dates: ProjectDates | undefined;
  handleEditDatesClick: () => void;
  currentUserType?: UserType;
}

export const PhaseLifecycle = ({ dates, handleEditDatesClick, currentUserType }: PhaseLifecycleProps): JSX.Element => {
  const isEmpty =
    !dates ||
    (!dates.feasibility?.start &&
      !dates.feasibility?.end &&
      !dates.design?.start &&
      !dates.design?.end &&
      !dates.implementation?.start &&
      !dates.implementation?.end &&
      !dates.ongoingMonitoring?.overallStart &&
      !dates.ongoingMonitoring?.overallEnd);

  return (
    <div
      className={`PhaseLifecycle ${currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "AssetManagerPhaseLifecycle" : ""}`}
    >
      {currentUserType !== OrganisationTypeConstants.ASSET_MANAGER && (
        <div className="PhaseLifecycleHeader">
          <h3>Phase lifecycle</h3>
        </div>
      )}
      {isEmpty ? (
        <div className="EmptyPhaseLifecycleContainer">
          <div className="EmptyPhaseLifecycle">
            <p className="body1">
              Add phase dates to visualise your project&apos;s lifecycle, from feasibility to ongoing monitoring
            </p>
            <Button
              text="Add Phase Dates"
              icon={<CalandarWhiteIcon />}
              onClick={handleEditDatesClick}
              iconPosition="left"
            />
          </div>
        </div>
      ) : (
        <div className="PhaseLifecycleSteps">
          <PhaseSection
            phase="Feasibility"
            start={dates?.feasibility?.start}
            end={dates?.feasibility?.end}
            status={dates?.feasibility?.status as ProjectPhaseStatus}
          />
          <PhaseSection
            phase="Design"
            start={dates?.design?.start}
            end={dates?.design?.end}
            status={dates?.design?.status as ProjectPhaseStatus}
          />
          <PhaseSection
            phase="Implementation"
            start={dates?.implementation?.start}
            end={dates?.implementation?.end}
            status={dates?.implementation?.status as ProjectPhaseStatus}
          />
          <PhaseSection
            phase="Ongoing monitoring"
            start={dates?.ongoingMonitoring?.overallStart}
            end={dates?.ongoingMonitoring?.overallEnd}
            status={dates?.ongoingMonitoring.overallStatus as ProjectPhaseStatus}
          />
        </div>
      )}
    </div>
  );
};
